import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { BasePage } from '../base.page';
import { NavController, ToastController, AlertController } from '@ionic/angular';
import { AvaliacaoModel } from 'projects/core/src/lib/core/model/AvaliacaoModel';
import { AvaliacaoViewModel } from './AvaliacaoViewModel';
import { ItemAvaliacaoModel } from 'projects/core/src/lib/core/model/ItemAvaliacaoModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';

@Component({
    selector: 'avaliacao-page',
    templateUrl: 'avaliacao.page.html',
    styleUrls: ['avaliacao.page.scss']
})
export class AvaliacaoPage extends BasePage {
    constructor(
        public router: Router, 
        private navCtrl: NavController, 
        public toastCtrl: ToastController,
        public alertController: AlertController) {
        super(router)
    }

    emRequisicao: Boolean = false
    avaliacoes: Array<ItemAvaliacaoModel>
    avaliacaoModel: AvaliacaoModel
    avaliacaoViewModel: AvaliacaoViewModel
    alertComponent: AlertComponent
    opcao = 0

    ngOnInit() {
        this.inicializarVariaveis()
    }

    inicializarVariaveis() {
        this.avaliacoes = ItemAvaliacaoModel.getListaAvaliacoes()
        this.avaliacaoModel = new AvaliacaoModel()
        this.avaliacaoViewModel = new AvaliacaoViewModel()
        this.avaliacaoViewModel.setContext(this)
    }

    checkItemOpcaoEmoji(opcao) {
        if (opcao == this.opcao) {
            this.opcao = 0
        } else {
            this.opcao = opcao
            this.avaliacaoModel.opcao = this.opcao
        }
    }

    async enviaAvaliacao() {
        try {
          this.emRequisicao = true
          await this.avaliacaoViewModel.enviaAvaliacao(this.avaliacaoModel)
        } catch(e) {
          AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT)
        }
        setTimeout(() => {
          this.emRequisicao = false
        }, 1000)
      }

    mensagemSucessoAlteracao(message: string) {
        this.showToast(message)
        this.navCtrl.back();
    }

    mensagemFalhaAlteracao(message: string) {
        this.showToast(message)
    }

    async showToast(message: string) {
        let toast = await this.toastCtrl.create({
            message,
            duration: 3000,
            position: 'top'
        });
        toast.present();
    }

    validaPrenchido(): Boolean {
        if (this.avaliacaoModel.opcao == 0) {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário escolher uma opção de avaliação')
            return false;
        }
        return true;
    }

    btnEnviar() {
        if (this.validaPrenchido()) {
            this.enviaAvaliacao()
        }
    }

    fecharTela() {
        this.navCtrl.pop()
    }

    eventScroll(event) {
        const rootPage = document.getElementsByTagName('avaliacao-page')[0];

        const ionHeader = rootPage.getElementsByTagName('ion-toolbar')[0]
        const ionTitle = rootPage.getElementsByTagName('ion-title')[0]

        if (event.detail.scrollTop === 0) {
            ionHeader.style.backgroundColor = "transparent"
            ionHeader.style.boxShadow = "none"
            ionTitle.style.color = "transparent"
        }
        else if (event.detail.scrollTop > 0) {
            ionHeader.style.backgroundColor = "#ffffff"
            ionHeader.style.boxShadow = "rgba(0, 0, 0, 0.2) 0px 2px 3px 0px"
            ionTitle.style.color = "#1846bb"
        }
    }
}
